// extracted by mini-css-extract-plugin
export default {"root":"DateRangePicker_root__8e3lJ"};